export default "__VITE_ASSET__RffG1j7c__"